import { GrupoContacto } from '@shared/enums/GrupoContacto';
import { Producto } from './Producto';
import { UltimoEstado } from './UltimoEstado';

export class Pedido {
    id: string;
    fechaHora: string;
    producto: Producto;
    cantidadPedida: number;
    cantidadIngresada: number;
    ultimoEstado: UltimoEstado;
    gruposContacto: GrupoContacto[];
    emails: string[];
}
